import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";


export const updateHubungkanAkunLamudi = async (data, user_id) => {
  return api({}, true).post(
    `/${PUBLIC_V1}/users/lamudi-olx-agent?user_id=${user_id}`,
    data
  );
};

export const updateHubungkanAkunRumah123 = async (data, user_id) => {
  return api({}, true).post(
    `/${PUBLIC_V1}/users/rumah123-agent?user_id=${user_id}`,
    data
  );
};

export const updateHubungkanAkunBeliRumahCo = async (data, user_id) => {
  return api({}, true).post(
    `/${PUBLIC_V1}/users/belirumah-agent?user_id=${user_id}`,
    data
  );
};

export const deleteAkunHubungkan = async (data, user_id) => {
  return api({}, true).delete(
    `/${PUBLIC_V1}/users/unlink-agent-portal?user_id=${user_id}`,
    { data }
  );
};

export const getListAkunHubungkan = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : ""
  return api({}, true).get(
    `/${PUBLIC_V1}/users/flagging-portal${newParams ? `?${newParams}` : ""}`
  );
};
